import { useEffect } from 'react'

interface SEOProps {
  title?: string
  description?: string
  canonical?: string
}

export const useSEO = ({ title, description, canonical }: SEOProps) => {
  useEffect(() => {
    if (title) {
      document.title = title
    }

    const metaDescription = document.querySelector('meta[name="description"]')
    if (description && metaDescription) {
      metaDescription.setAttribute('content', description)
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]')
    if (canonical && canonicalLink) {
      canonicalLink.setAttribute('href', canonical)
    }

    return () => {
      // Reset to default on unmount
      document.title = 'Junior Entreprise HEPIA — Des étudiants qui livrent'
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Conseil étudiant en logiciel, IA, robotique, électronique et design. De l\'idée au livrable.')
      }
      if (canonicalLink) {
        canonicalLink.setAttribute('href', 'https://je-hepia.ch/')
      }
    }
  }, [title, description, canonical])
}